/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const LockPerson = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 20 20" fill="none">
      <g clipPath="url(#clip0_2068_14837)">
        <path
          d="M4.99882 16.6683V8.33496H14.9988V9.16829C15.5822 9.16829 16.1405 9.25163 16.6655 9.40996V8.33496C16.6655 7.41829 15.9155 6.66829 14.9988 6.66829H14.1655V5.00163C14.1655 2.70163 12.2988 0.834961 9.99882 0.834961C7.69882 0.834961 5.83215 2.70163 5.83215 5.00163V6.66829H4.99882C4.08215 6.66829 3.33215 7.41829 3.33215 8.33496V16.6683C3.33215 17.585 4.08215 18.335 4.99882 18.335H10.2155C9.86549 17.835 9.59049 17.2683 9.40715 16.6683H4.99882ZM7.49882 5.00163C7.49882 3.61829 8.61549 2.50163 9.99882 2.50163C11.3822 2.50163 12.4988 3.61829 12.4988 5.00163V6.66829H7.49882V5.00163Z"
          fill="currentColor"
        />
        <path
          d="M14.9988 10.835C12.6988 10.835 10.8322 12.7016 10.8322 15.0016C10.8322 17.3016 12.6988 19.1683 14.9988 19.1683C17.2988 19.1683 19.1655 17.3016 19.1655 15.0016C19.1655 12.7016 17.2988 10.835 14.9988 10.835ZM14.9988 12.5016C15.6905 12.5016 16.2488 13.06 16.2488 13.7516C16.2488 14.4433 15.6905 15.0016 14.9988 15.0016C14.3072 15.0016 13.7488 14.4433 13.7488 13.7516C13.7488 13.06 14.3072 12.5016 14.9988 12.5016ZM14.9988 17.5016C14.1405 17.5016 13.3822 17.0683 12.9322 16.4016C13.5405 16.0516 14.2405 15.835 14.9988 15.835C15.7572 15.835 16.4572 16.0516 17.0655 16.4016C16.6155 17.0683 15.8572 17.5016 14.9988 17.5016Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2068_14837">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </BaseSvgIcon>
  )
}

export default LockPerson
